/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoSbpIcon16Light } from './LogoSbpIcon16Light';
import { LogoSbpIcon16Regular } from './LogoSbpIcon16Regular';
import { LogoSbpIcon16Solid } from './LogoSbpIcon16Solid';
import { LogoSbpIcon20Light } from './LogoSbpIcon20Light';
import { LogoSbpIcon20Regular } from './LogoSbpIcon20Regular';
import { LogoSbpIcon20Solid } from './LogoSbpIcon20Solid';
import { LogoSbpIcon24Regular } from './LogoSbpIcon24Regular';
import { LogoSbpIcon24Solid } from './LogoSbpIcon24Solid';
import { LogoSbpIcon32Regular } from './LogoSbpIcon32Regular';
import { LogoSbpIcon64Regular } from './LogoSbpIcon64Regular';
var sizes = {
    16: {
        light: LogoSbpIcon16Light,
        regular: LogoSbpIcon16Regular,
        solid: LogoSbpIcon16Solid,
    },
    20: {
        light: LogoSbpIcon20Light,
        regular: LogoSbpIcon20Regular,
        solid: LogoSbpIcon20Solid,
    },
    24: {
        regular: LogoSbpIcon24Regular,
        solid: LogoSbpIcon24Solid,
    },
    32: {
        regular: LogoSbpIcon32Regular,
    },
    64: {
        regular: LogoSbpIcon64Regular,
    },
};
export var LogoSbpIcon = forwardRef('LogoSbpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
